import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './dot.module.scss';

const METADATA = Metadata.define({
  description: 'Alert dot badge indicator.',
  name: 'Dot Alert Badge',
});

export default class SpdsIndicatorBadgeDotAlert extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-indicator-badge-dot';
  variantClass = 'spds-indicator-badge-dot-alert';
  variantStyles = styles;
}

export const BADGE_DOT_ALERT_METADATA = SpdsIndicatorBadgeDotAlert.metadata;
